import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/userActions';
import MenuItem from '../ui/MenuItem';
import './SwitchGroup.scss';
import { KEY_ESCAPE } from '../../constants/keyboardCodes';
import GlobalShortcut from '../GlobalShortcut';
import ToolbarButton from '../../components/toolbar/ToolbarButton';
import { tankersUnstructuredDatasetIds } from '_legacy/models/Datasets';
import { UserApi } from 'api';
import store from 'store';

export class SwitchGroup extends Component {
    constructor(props, context) {
        super(props, context);
        this.onClick = this.onClick.bind(this);
        this.handleMenuOnClick = this.handleMenuOnClick.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.menuRef = createRef();
        this.buttonRef = createRef();
        this.state = { menuOpen: false };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (
            this.state.menuOpen &&
            this.menuRef.current &&
            !this.menuRef.current.contains(event.target) &&
            !this.buttonRef.current.contains(event.target)
        ) {
            this.setState({ menuOpen: false });
        }
    };

    onClick(e, group) {
        e.preventDefault();
        e.stopPropagation();
        this.props.actions.groupSet(group);
        this.props.onChange();
        UserApi.updateRetainedAppState(
            store.getState().user.uiSettings.retainedView,
            group.id
        );
        this.setState({ menuOpen: false });
    }

    handleMenuOnClick(e) {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    closeMenu() {
        this.setState({ menuOpen: false });
    }

    onEscape(event) {
        return event.keyCode === KEY_ESCAPE;
    }

    filterUnstructured(groups) {
        return groups.filter(
            (g) => !tankersUnstructuredDatasetIds.includes(g.datasetId)
        );
    }

    render() {
        const groups = this.props.vesselView
            ? this.filterUnstructured(this.props.groups)
            : this.props.groups;

        if (groups && groups.length > 1) {
            let currentGroups = groups.filter(
                (g) => g.id === this.props.currentGroupId
            );

            if (currentGroups.length === 0) {
                const firstGroup = groups[0];
                this.props.actions.groupSet(firstGroup);
                this.props.onChange();
                currentGroups = [firstGroup];
            }

            const currentGroup = currentGroups[0];

            var submenu = null;

            if (this.state.menuOpen) {
                submenu = (
                    <GlobalShortcut
                        onMatch={this.closeMenu}
                        keyMatcher={this.onEscape}
                    >
                        <ul className="switchgroup-dropdown" ref={this.menuRef}>
                            {groups.map((g) => (
                                <li
                                    key={g.id}
                                    onClick={(e) => this.onClick(e, g)}
                                >
                                    {g.name}
                                </li>
                            ))}
                        </ul>
                    </GlobalShortcut>
                );
            }

            return (
                <ToolbarButton
                    onClick={this.handleMenuOnClick}
                    style={{ padding: '10px' }}
                    ref={this.buttonRef}
                >
                    {currentGroup.name} {submenu}
                </ToolbarButton>
            );
        } else if (groups && groups.length === 0) {
            return (
                <MenuItem>
                    <div className="ui negative large fluid message">
                        <div className="header">
                            You have not been assigned a group, please contact{' '}
                            <a href="mailto:digital.brokingcore@clarksons.com">
                                digital.brokingcore@clarksons.com
                            </a>{' '}
                            to be assigned a group.
                            {this.props.isAdmin && (
                                <div style={{ float: 'right' }}>
                                    <a href="/admin/groups">
                                        Click here to navigate to the Admin page
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </MenuItem>
            );
        }
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        currentGroupId:
            state.user && state.user.group ? state.user.group.id : null,
        groups: state.user && state.user.groups ? state.user.groups : null,
        permissions:
            state.user && state.user.permissions
                ? state.user.permissions
                : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(userActions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchGroup);
